import { lazy } from 'react';
import { paths } from './paths';

const CommunityHome = lazy(() => import('src/pages/communityHome/communityHome'));
const CommunityDetails = lazy(() => import('src/pages/CommunityDetails'));
const CommunityPostScheduleDetails = lazy(() => import('src/pages/CommunityDetails/Posts/PostConsumption/PostScheduleDetails/postScheduleDetails'));
const CommunityPostDetails = lazy(() => import('src/pages/CommunityDetails/Posts/PostConsumption/PostBottomsheet'));
const CommunityPostCollaborativeDetails = lazy(() => import('src/pages/CommunityDetails/Posts/PostConsumption/PostBottomsheet'));
const SingleMigration = lazy(() => import('src/pages/Migration/single/singleMigration'));
const SelectedMigration = lazy(() => import('src/pages/Migration/selected/selectedMigration'));
const PageNotFound = lazy(() => import('src/components/EmptyNotFound'));

const normalizePath = (path: string) => {
  return path.replace(paths.COMMUNITIES_PATH, '');
};

const routes = [
  {
    path: paths.HOME_PATH,
    component: CommunityHome,
    index: true
  },
  {
    path: normalizePath(paths.SELECTED_MIGRATION_PATH),
    component: SelectedMigration
  },
  {
    path: normalizePath(paths.SINGLE_MIGRATION_PATH),
    component: SingleMigration
  },
  {
    path: normalizePath(paths.COMMUNITY_PATH),
    component: CommunityDetails
  },
  {
    path: normalizePath(paths.COMMUNITY_SCHEDULED_POST_PATH),
    component: CommunityPostScheduleDetails
  },
  {
    path: normalizePath(paths.COMMUNITY_COLLABORATIVE_POST_PATH),
    component: CommunityPostCollaborativeDetails
  },
  {
    path: normalizePath(paths.COMMUNITY_POST_PATH),
    component: CommunityPostDetails
  },
  // WARNING: keep this path at the end of the array
  {
    path: '*',
    component: PageNotFound
  }
];

export default routes;
